export const LOGIN_USER = 'LOGIN_USER';
export const RESET_LOGIN_DATA = 'RESET_LOGIN_DATA';
export const ADMIN_USER_INFO = 'ADMIN_USER_INFO';
